module.exports = __webpack_public_path__ + "static/media/hover.79de3960.svg";